const technology_list = [
  {
    name: 'Figma',
    URL: 'https://www.figma.com/',
    image: 'figmaLogo.png'
  },
  {
    name: 'HTML',
    URL: 'https://html.com/',
    image: 'htmlLogo.png'
  },
  {
    name: 'JavaScript',
    URL: 'https://javascript.info/',
    image: 'javascriptLogo.png'
  },
  {
    name: 'React JS',
    URL: 'https://react.dev/',
    image: 'reactLogo.png'
  },
  {
    name: 'C',
    URL: 'https://devdocs.io/c/',
    image: 'CLangLogo.png'
  },
  
  {
    name: 'Java',
    URL: 'https://www.java.com/en/',
    image: 'javaLogo.png'
  },
  
  {
    name: 'Python',
    URL: 'https://www.python.org/',
    image: 'pythonLogo.png'
  },
  
  {
    name: 'MySQL',
    URL: 'https://dev.mysql.com/doc/',
    image: 'mysqlLogo.png'
  },
  
  
]

export default technology_list;